module.exports = "/assets/images/sign-up-illustration.svg";